import cx from "classnames";
import React, { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { AnimatePresence, motion } from "framer-motion";
import Icon from "components/CommonIcon/Icon";

const variants = {
  enter: {
    opacity: 0,
    y: 30,
    transition: {
      duration: 0.3,
    },
  },
  animate: {
    opacity: 1,
    y: 20,
    transition: {
      duration: 0.3,
    },
    display: "block",
  },
  exit: {
    opacity: 0,
    y: 30,
    transition: {
      duration: 0.2,
    },
    transitionEnd: {
      display: "none",
    },
  },
};

const colors = {
  black: "bg-gray-text",
  white: "white",
};

const Tooltip = ({
  children,
  trigger,
  tooltipPosition,
  icon,
  toolTipColor,
  openOnHover,
}) => {
  const [showOnHover, setShowOnHover] = useState(false);
  const [showOnClick, setShowOnClick] = useState(false);
  const toggleShow = () => {
    setShowOnHover((s) => !s);
  };
  const hideToolTip = () => {
    setShowOnHover(false);
    setShowOnClick(false);
  };

  const blockPropogation = (e) => {
    e.stopPropagation();
    setShowOnClick(true);
  };

  return (
    <OutsideClickHandler onOutsideClick={hideToolTip}>
      <motion.div
        onHoverStart={openOnHover && toggleShow}
        onHoverEnd={openOnHover && toggleShow}
        onClick={blockPropogation}
        className="relative flex items-center cursor-pointer group">
        <AnimatePresence>
          {(showOnHover || showOnClick) && (
            <motion.div
              className="w-full absolute z-1"
              variants={variants}
              initial="enter"
              animate="animate"
              exit="exit">
              <div
                className={cx(
                  `absolute transform rounded flex items-center transition-all duration-300 top-full z-100
           shadow-card-booking-benefit bg-white w-max`,
                  {
                    "left-1/2 -translate-x-1/2": tooltipPosition === "center",
                    "left-0": tooltipPosition === "left",
                    "right-0": tooltipPosition === "right",
                  }
                )}>
                <div
                  className={cx(
                    "bg-white h-12 w-12 absolute top-0 transform rotate-45 -translate-x-1/2 -translate-y-1/2",
                    {
                      "left-1/2": tooltipPosition === "center",
                      "left-1/18": tooltipPosition === "left",
                      "right-1/18": tooltipPosition === "right",
                      [colors[toolTipColor]]: toolTipColor,
                    }
                  )}
                />
                {children}
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        <div className="flex items-center">
          <span className="mr-4">{trigger}</span>
          <span className="flex">
            <span
              className={cx("transform duration-300", {
                "rotate-180": showOnHover || showOnClick,
              })}>
              {icon || (
                <Icon
                  name="chevron-down"
                  color="text-white"
                  fontSize="text-12"
                />
              )}
            </span>
          </span>
        </div>
      </motion.div>
    </OutsideClickHandler>
  );
};

Tooltip.defaultProps = {
  tooltipPosition: "center",
  toolTipColor: "white",
  openOnHover: true,
};

export default Tooltip;
